export const Crash = () => {
  return (
    <div>
      <h2>&#3232;_&#3232; Ooops</h2>
    </div>
  );
};
